import { NetworkProps } from '@dapp/multi-lib/network';
import { Body2 } from 'components/Typography';
import Image from 'next/image';
import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { useClickOutside } from 'utils/hooks/useClickOutside';

export interface BridgeNetworkOption {
  id: NetworkProps['id'];
  network: NetworkProps;
  subtitle: string;
  imgUrl: string;
}

interface BridgeNetworkListProps {
  open: boolean;
  options: BridgeNetworkOption[];
  onChange: (value: BridgeNetworkOption) => void;
  onClickOutside: () => void;
  fullWidthOverlay?: boolean;
}

export const BridgeNetworkList = (props: BridgeNetworkListProps) => {
  const {
    open,
    options,
    onClickOutside,
    onChange,
    fullWidthOverlay = false,
  } = props;
  const ref = useRef<HTMLDivElement>(null);

  useClickOutside(ref, onClickOutside, open);

  if (!open) return null;

  return (
    <div
      className={twMerge(
        'z-10 mt-[4px] w-full',
        fullWidthOverlay ? 'absolute left-0 top-full' : 'relative'
      )}
    >
      <div
        className={twMerge(
          'absolute max-h-[200px] w-full overflow-y-auto border-[0.4px] border-[#333333] bg-[#1E1E1E]',
          fullWidthOverlay && 'relative'
        )}
      >
        <div
          ref={ref}
          className='flex flex-col rounded-[8px] bg-[#1E1E1E] p-[10px] text-white'
        >
          {options.map((option) => (
            <div
              key={option.id}
              onClick={() => onChange(option)}
              className='flex cursor-pointer flex-row items-center gap-[10px] px-[6px] py-[10px]'
            >
              <Image
                src={option.imgUrl}
                className='rounded-full'
                alt={option.subtitle}
                width={24}
                height={24}
              />
              <Body2>{option.subtitle}</Body2>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
